import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    NavLink,
    Redirect,
    Route,
    Switch
} from 'react-router-dom';

import classNames from './../utils/classNames';

import Nav from './../components/Nav';

import MyOrdersProgressPage from './MyOrdersProgressPage';
import MyOrdersCompletePage from './MyOrdersCompletePage';

import { ordersProgressFetchIfNeeded } from './../store/ordersProgress/actions';
import { ordersCompleteFetchIfNeeded } from './../store/ordersComplete/actions';

import {
    getHasUnreadMessagesOrdersProgress,
    getHasUnreadMessagesOrdersComplete
} from './../store/notification/selectors'

class MyOrdersPage extends Component {
    componentDidMount() {
        const { loadOrders } = this.props;
        loadOrders();
    }

    render() {
        const {
            match,
            hasUnreadProgress,
            hasUnreadComplete
        } = this.props;
        const progressClassName = classNames({ 'new': hasUnreadProgress });
        const completeClassName = classNames({ 'new': hasUnreadComplete });

        return (
            <div>
                <Nav sub>
                    <NavLink className={progressClassName} to={`${match.url}/inprogress`}>In Progress</NavLink>
                    <NavLink className={completeClassName} to={`${match.url}/completed`}>Completed</NavLink>
                </Nav>
                <Switch>
                    <Route path={`${match.url}/inprogress/:orderNumber`} component={MyOrdersProgressPage} />
                    <Route path={`${match.url}/inprogress`} component={MyOrdersProgressPage} />
                    <Route path={`${match.url}/completed/:orderNumber`} component={MyOrdersCompletePage} />
                    <Route path={`${match.url}/completed`} component={MyOrdersCompletePage} />
                    <Redirect from={match.url} exact to={{ pathname: `${match.url}/inprogress`, search: window.location.search }} push={false} />
                </Switch>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const hasUnreadProgress = getHasUnreadMessagesOrdersProgress(state);
    const hasUnreadComplete = getHasUnreadMessagesOrdersComplete(state);
    return { hasUnreadProgress, hasUnreadComplete };
};

const mapDispatchToProps = dispatch => ({
    loadOrders: () => {
        dispatch(ordersProgressFetchIfNeeded());
        dispatch(ordersCompleteFetchIfNeeded());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(MyOrdersPage);


// WEBPACK FOOTER //
// ./src/pages/MyOrdersPage.js